import { IErrorSectionData } from "src/typings/error-section-data";
import { RendererBase } from "src/shared/renderer-base";
import { IRenderingCommonContext } from "@commonRendering/types";

export class ErrorSectionRenderer extends RendererBase<IErrorSectionData> {

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
    }

    protected override createNewInternal(): HTMLElement {
        const element = document.createElement("section");
        element.setAttribute("data-section", "errorSection");
        element.id = "error-section";

        return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderInternal(element: HTMLElement, data: IErrorSectionData): HTMLElement {
        this.cleanupInternal(element);
        return element;
    }

    protected override cleanupInternal(element: HTMLElement): void {
        const content = element.querySelector<HTMLElement>(".content");
        if (!content) {
            return;
        }
        content.innerHTML = "";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [];
    }

}
